import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { useDocumentMeta } from '../hooks/useDocumentMeta';
import { site } from '../data/site';
import { buttonStyles, container } from '../utils/styles';
export function NotFound() {
  const {
    t
  } = useLanguage();
  useDocumentMeta('notFound');
  return <section className="bg-cream py-24 sm:py-32" data-id="element-560" data-mp="152uygvqrqzz7">
      <div className={`${container} max-w-2xl text-center`} data-id="element-561" data-mp="1a4u2m7uc20x7">
        <h1 className="text-4xl font-bold text-ink sm:text-5xl" data-id="element-562" data-mp="1a27uo73j5jeg">{t({
          en: 'Page not found',
          es: 'Página no encontrada'
        })}</h1>
        <p className="mt-4 text-lg text-ink-soft" data-id="element-563" data-mp="1jtc12if53vxo">
          {t({
          en: 'We couldn’t find that page. If you need care, we’re here 24/7.',
          es: 'No encontramos esa página. Si necesitas cuidado, estamos aquí 24/7.'
        })}
        </p>
        <div className="mt-8 flex flex-col justify-center gap-3 sm:flex-row" data-id="element-564" data-mp="1ssflpqtygjea">
          <Link to="/" className={buttonStyles.primary} data-id="element-565" data-mp="1xu4ueztpgkz7">
            {t({
            en: 'Back to Home',
            es: 'Volver al Inicio'
          })}
          </Link>
          <a href={site.tel} className={buttonStyles.outline} data-id="element-566" data-mp="1iwr3xdhr1vtx">
            {site.phoneDisplay}
          </a>
        </div>
      </div>
    </section>;
}